// extracted by css-extract-rspack-plugin
export default {"container":"_28227725","inputWrapper":"_cb4c3d07","button":"_a3c35cd4","searchInput":"_daa219a"};